import { fetchCatalogsIfNeeded, getCatalog } from './catalog';
import { fetchBidIncrementsIfNeeded } from './bidIncrements';
import { fetchCatalogBiddingIfNeeded } from './catalogBiddingInfo';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail';
import { fetchCatalogItemsIfNeeded } from './catalogItems';
import { fetchConsoleBrandingIfNeeded } from './consoleBranding';
import { fetchCoverLotsIfNeeded } from './coverLots';
import { fetchCurrencyConversionsIfNeeded } from './currency';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSellersIfNeeded } from './seller';
import { fetchStreamIdIfNeeded } from './video';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

/* ACTION CREATORS */
export const fetchDataForBiddingConsolePage = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    const url = getNotFoundUrl();
    // If we dont have the catalogId here then we're going to abort
    if (!catalogId) {
        return Promise.all([dispatch(push(url))]);
    }

    await Promise.all([
        dispatch(fetchBidIncrementsIfNeeded(catalogId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCatalogsIfNeeded([catalogId])),
        dispatch(fetchCatalogBiddingIfNeeded(catalogId)),
        dispatch(fetchCoverLotsIfNeeded([catalogId])),
        dispatch(fetchCatalogItemsIfNeeded(catalogId, false, 1, 'all')),
        dispatch(fetchCurrencyConversionsIfNeeded()),
        dispatch(fetchStreamIdIfNeeded(catalogId)),
    ]);

    const state = getState();
    const catalog = getCatalog(state, catalogId);

    if (!catalog || !catalog.catalogId) {
        return Promise.all([dispatch(push(url))]);
    }

    const promises = [
        dispatch(fetchSellersIfNeeded([catalog.sellerId])),
        dispatch(fetchSellersDetailsIfNeeded([catalog.sellerId])),
        dispatch(fetchConsoleBrandingIfNeeded(catalogId, catalog.sellerId)),
    ];

    return Promise.all(promises);
};
